import { environment } from "@/enviroment";

export class UserRepository implements IUserRepository {
  private baseUrl = `${environment.openBaas}/v1/users`;

  private get fetchOptions() {
    return {
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include" as RequestCredentials,
    };
  }

  async update(user: Partial<User>): Promise<User> {
    const response = await fetch(`${this.baseUrl}`, {
      ...this.fetchOptions,
      method: "PUT",
      body: JSON.stringify({ ...user, updated: new Date() }),
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error(`Error updating user: ${error}`);
    }

    return await response.json();
  }

  async get(): Promise<User> {
    const response = await fetch(`${this.baseUrl}`, {
      ...this.fetchOptions,
      method: "GET",
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error(`Error getting user: ${error}`);
    }

    return await response.json();
  }
}

export const userRepository = new UserRepository();
